import { Service } from '@/types'

export const clinicServices: Service[] = [
  {
    id: 'muahale-girisim',
    title: 'Müdahale ve Girişim Alanları',
    description: 'Damar yolu açma, oksijen desteği, yara bakımı ve küçük girişimler için aseptik, hızlı erişilebilir alanlar. Hastaların ABC stabilizasyonu ve acil durum protokolleri burada başlatılır. İleri yaşam desteği ekipmanları hazır bekletilir; izlem ve kayıt süreçleri standardize edilmiştir.',
    icon: 'Activity',
    category: 'clinic',
    slug: 'mudahale-ve-girisim-alanlari',
    image: '/klinik.webp',
    highlights: [
      'Aseptik müdahale alanları',
      'Venöz erişim ve sıvı tedavisi',
      'Oksijen ve nebulizasyon desteği',
      'Yara bakımı ve küçük girişimler'
    ]
  },
  {
    id: 'muayene-odalari',
    title: 'Muayene Odaları',
    description: 'Stres azaltıcı yaklaşım (fear‑free), hassas tartım, vital bulgu takibi ve sistematik fizik muayene için tasarlanmış odalar. Mahremiyet ve hijyen önceliklidir. Kedi ve köpek dostlarımız için ayrı bekleme ve muayene düzenleri ile stres minimuma indirilir.',
    icon: 'Stethoscope',
    category: 'clinic',
    slug: 'muayene-odalari',
    image: '/klinik.webp',
    highlights: [
      'Fear‑free yaklaşım ve sakinleştirici ortam',
      'Hassas tartım ve vital bulgu takibi',
      'Mahremiyet ve hijyen odaklı tasarım'
    ]
  },
  {
    id: 'ameliyathane',
    title: 'Ameliyathane',
    description: 'HEPA filtrasyonlu, sterilizasyon protokollerine uygun ameliyathane; anestezi monitörizasyonu (EKG, SpO₂, NIBP, ETCO₂) ve gelişmiş ağrı yönetimi ile güvenli cerrahi. Sterilizasyon logları ve ekipman kalibrasyonları düzenli olarak takip edilir.',
    icon: 'Surgery',
    category: 'clinic',
    slug: 'ameliyathane',
    image: '/klinik.webp',
    highlights: [
      'HEPA filtrasyonlu ameliyathane',
      'Anestezi monitörizasyonu (EKG, SpO₂, NIBP, ETCO₂)',
      'Sterilizasyon ve güvenli cerrahi protokolleri',
      'Multimodal ağrı yönetimi'
    ],
    preparation: [
      'Operasyon öncesi 8–12 saat açlık',
      'Kronik ilaçlar ve alerjilerin bildirilmesi'
    ]
  },
  {
    id: 'tibbi-goruntuleme',
    title: 'Tıbbi Görüntüleme',
    description: 'Dijital röntgen ve ultrason ile göğüs‑karın değerlendirmesi, ortopedik görüntüleme ve gebelik takibi. Hızlı tanı ve hedefe yönelik tedavi planı sağlar. Acil olgularda hızlı raporlama ile tedaviye zaman kaybetmeden başlanır.',
    icon: 'Scan',
    category: 'clinic',
    slug: 'tibbi-goruntuleme',
    image: '/klinik.webp',
    highlights: [
      'Dijital röntgen (DR) ile hızlı görüntüleme',
      'Abdominal ultrasonografi',
      'Ortopedik ve toraks değerlendirme'
    ],
    preparation: [
      'Ultrason öncesi 6–8 saat açlık (önerilir)'
    ]
  },
  {
    id: 'klinik-laboraturvar',
    title: 'Klinik Laboratuvar',
    description: 'Tam kan sayımı, biyokimya, idrar analizi, hızlı tanı testleri ve sitoloji ile saatler içinde sonuç. Tedavi kararlarını bilimsel veriye dayandırır. Kritik değer uyarı sistemi ile hekime anlık bildirim sağlanır.',
    icon: 'TestTube',
    category: 'clinic',
    slug: 'klinik-laboraturvar',
    image: '/klinik.webp',
    highlights: [
      'CBC ve biyokimya panelleri',
      'İdrar analizi ve hızlı tanı testleri',
      'Sitoloji ve smear değerlendirmesi'
    ]
  },
  {
    id: 'egitim-danisan',
    title: 'Eğitim ve Danışan Alanları',
    description: 'Beslenme, kilo yönetimi, davranış, kronik hastalık takibi ve taburculuk sonrası bakım için net ve uygulanabilir danışmanlık. Sahip eğitimi, evde bakım protokolleri ve takip planları ile sürdürülebilir sağlık hedeflenir.',
    icon: 'GraduationCap',
    category: 'clinic',
    slug: 'egitim-ve-danisan-alanlari',
    image: '/klinik.webp',
    highlights: [
      'Beslenme ve kilo yönetimi planları',
      'Kronik hastalık takibi ve eğitim',
      'Taburculuk sonrası bakım rehberi'
    ]
  },
  {
    id: 'pet-oteli',
    title: 'Pet Oteli',
    description: 'Aşı kontrolü, ayrı alanlama ve günlük egzersiz rutini ile güvenli konaklama. Özel diyet ve ilaç uygulamaları protokole uygun yürütülür. Günlük aktivite ve beslenme planları sahiplerine düzenli olarak raporlanır.',
    icon: 'Home',
    category: 'clinic',
    slug: 'pet-oteli',
    image: '/klinik.webp',
    highlights: [
      'Aşılama kontrolü ve güvenli kabul',
      'Ayrı alanlama ve günlük egzersiz',
      'Özel diyet ve ilaç uygulamaları'
    ],
    preparation: [
      'Aşı karnesi ve düzenli ilaçların getirilmesi',
      'Mama ve özel bakım talimatlarının paylaşılması'
    ]
  },
  {
    id: 'pet-kuafor',
    title: 'Pet Kuaför',
    description: 'Irka özgü tıraş, banyo, tırnak‑kulak bakımı ve hijyenik tıraş. Gerekli olgularda veteriner gözetiminde sedasyon seçenekleri. Cilt ve tüy sağlığını destekleyen ürünler kullanılır; işlem sonrası bakım önerileri verilir.',
    icon: 'Scissors',
    category: 'clinic',
    slug: 'pet-kuafor',
    image: '/klinik.webp',
    highlights: [
      'Banyo ve fırçalama',
      'Irka özgü tıraş seçenekleri',
      'Tırnak ve kulak bakımı'
    ]
  }
]

export const medicalServices: Service[] = [
  {
    id: 'acil-tedavi',
    title: 'Acil Tedavi',
    description: '7/24 triyaj, şok yönetimi, travma ve zehirlenmelerde hızlı stabilizasyon (ABC), ağrı kontrolü ve ileri sevk gerektirmeyen acil girişimler.',
    icon: 'AlertTriangle',
    category: 'services',
    slug: 'acil-tedavi',
    image: '/klinik.webp',
    highlights: [
      'Hızlı triyaj ve stabilizasyon',
      'Travma ve zehirlenmelerde acil yaklaşım',
      'Ağrı ve bulantı kontrol protokolleri'
    ]
  },
  {
    id: 'agiz-dis',
    title: 'Ağız ve Diş',
    description: 'Diş taşı temizliği, dental röntgen, periodontal tedavi ve evde bakım eğitimi. Ağız sağlığı, genel sağlıkla yakından ilişkilidir.',
    icon: 'Smile',
    category: 'services',
    slug: 'agiz-ve-dis',
    image: '/klinik.webp',
    highlights: ['Dental scale & polish', 'Dental X‑ray', 'Periodontal tedavi'],
    preparation: ['12 saat açlık (genel anestezi planlandıysa)']
  },
  {
    id: 'cerrahi',
    title: 'Cerrahi',
    description: 'Yumuşak doku ve seçilmiş ortopedik cerrahiler. Preop risk sınıflaması, steril teknik ve multimodal analjezi ile güvenli süreç.',
    icon: 'Surgery',
    category: 'services',
    slug: 'cerrahi',
    image: '/klinik.webp',
    highlights: ['Preop risk sınıflaması', 'Steril ameliyathane', 'Multimodal ağrı yönetimi'],
    preparation: ['Gece yarısından sonra açlık', 'Düzenli ilaçların bildirilmesi']
  },
  {
    id: 'dahiliye',
    title: 'Dahiliye',
    description: 'Endokrin, gastrointestinal, hepatik ve renal hastalıklarda kan testleri, görüntüleme ve kanıta dayalı tedavi protokolleri.',
    icon: 'Stethoscope',
    category: 'services',
    slug: 'dahiliye',
    image: '/klinik.webp',
    highlights: ['Endokrin ve GI değerlendirme', 'Böbrek-karaciğer protokolleri']
  },
  {
    id: 'dermatoloji',
    title: 'Dermatoloji',
    description: 'Alerji, paraziter ve fungal hastalıklarda sitoloji, mantar kültürü ve alerji testleri ile hedefe yönelik tedavi ve bariyer bakımı.',
    icon: 'Droplets',
    category: 'services',
    slug: 'dermatoloji',
    image: '/klinik.webp',
    highlights: ['Sitoloji ve kültür', 'Alerji testleri', 'Bariyer onarımı']
  },
  {
    id: 'endoskopi',
    title: 'Endoskopi (Kolonoskopi–Bronkoskopi)',
    description: 'Minimal invaziv sindirim/solunum yolu incelemesi ve biyopsi. Daha hızlı iyileşme, daha az ağrı; işlem öncesi açlık ve güvenli anestezi şarttır.',
    icon: 'Search',
    category: 'services',
    slug: 'endoskopi',
    image: '/klinik.webp',
    highlights: ['Biyopsi alma', 'Yabancı cisim çıkarma'],
    preparation: ['12–18 saat açlık', 'Ön değerlendirme']
  },
  {
    id: 'evde-veteriner',
    title: 'Evde Veterinerlik Hizmeti',
    description: 'Aşılama, parazit önleme, genel muayene ve kronik hastalık takibinin ev konforunda sunulması. Stres ve taşıma kaygısı olan hastalar için idealdir. Acil/cerrahi gerektiren olgular kliniğe yönlendirilir.',
    icon: 'Home',
    category: 'services',
    slug: 'evde-veterinerlik-hizmeti',
    image: '/klinik.webp',
    highlights: [
      'Evde aşılama ve genel sağlık muayenesi',
      'İç‑dış parazit koruma ve uygulama',
      'Yaşlı ve kronik hastalarda takip',
      'Stres ve taşıma kaygısının azaltılması'
    ],
    preparation: [
      'Randevu öncesi temel şikayetleri not edin',
      'Evcil dostun rahat edeceği sessiz bir alan hazırlayın',
      'Son 6 aya ait tahlil ve aşı kayıtlarını hazır bulundurun'
    ]
  },
  {
    id: 'goruntuleme',
    title: 'Görüntüleme Hizmetleri',
    description: 'Dijital röntgen ve ultrason ile hızlı tanı; ortopedik, toraks ve abdominal değerlendirmeler. Sonuçlar aynı gün paylaşılır.',
    icon: 'Camera',
    category: 'services',
    slug: 'goruntuleme-hizmetleri',
    image: '/klinik.webp',
    highlights: ['Dijital röntgen', 'Abdominal USG', 'Dental radyografi']
  },
  {
    id: 'kardiyoloji',
    title: 'Kardiyoloji (EKG–EKO)',
    description: 'Kalp üfürümü, öksürük ve nefes darlığı şikayetlerinde EKG ve ekokardiyografi ile değerlendirme; evreye uygun medikal tedavi.',
    icon: 'Heart',
    category: 'services',
    slug: 'kardiyoloji',
    image: '/klinik.webp',
    highlights: ['EKG', 'Ekokardiyografi', 'İlaç titrasyonu']
  },
  {
    id: 'kbb',
    title: 'KBB (Kulak Burun Boğaz)',
    description: 'Otitis, rinit ve yabancı cisimlerde otoskopi/rinoskopi ile tanı; medikal tedavi ve gerekirse minimal invaziv girişimler. Kronik olgularda tekrarlamayı azaltan evde bakım önerileri sunulur.',
    icon: 'Ear',
    category: 'services',
    slug: 'kbb',
    image: '/klinik.webp'
  },
  {
    id: 'check-up',
    title: 'Kedi ve Köpekler için Check-Up',
    description: 'Yaşa özel tarama paketleri (kan, idrar, dışkı, görüntüleme) ile hastalıkları erken yakalama ve kişiye özel sağlık planı.',
    icon: 'CheckCircle',
    category: 'services',
    slug: 'check-up',
    image: '/klinik.webp',
    highlights: ['Kan-idrar testleri', 'Görüntüleme', 'Beslenme danışmanlığı']
  },
  {
    id: 'koruyucu-hekimlik',
    title: 'Koruyucu Hekimlik',
    description: 'Aşı takvimi, iç‑dış parazit önleme, mikroçip ve seyahat belgeleri. Hastalıkların büyük kısmı doğru korunma ile önlenebilir.',
    icon: 'Shield',
    category: 'services',
    slug: 'koruyucu-hekimlik',
    image: '/klinik.webp',
    highlights: ['Aşı planı', 'Parazit profilaksisi', 'Mikroçip']
  }
]

export const allServices = [...clinicServices, ...medicalServices]

